import { Deserializable } from '../../../../protocols/deserializable';
import { Address } from '../../../../users/dto/address';

export class EmployerUpdateAddressSubmission implements Deserializable {
  public previous!: EmployerUpdateAddressSubmissionData;
  public new!: EmployerUpdateAddressSubmissionData;

  public onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;

    if (!!this.new) {
      this.new = Deserialize?.instanceOf(EmployerUpdateAddressSubmissionData, this.new);
    }
    if (!!this.previous) {
      this.previous = Deserialize?.instanceOf(EmployerUpdateAddressSubmissionData, this.previous);
    }
  }
}

export class EmployerUpdateAddressSubmissionData implements Deserializable {
  public headOfficeAddress!: Address;
  public mailingAddress!: Address;

  public onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;

    if (!!this.headOfficeAddress) {
      this.headOfficeAddress = Deserialize?.instanceOf(Address, this.headOfficeAddress);
    }
    if (!!this.mailingAddress) {
      this.mailingAddress = Deserialize?.instanceOf(Address, this.mailingAddress);
    }
  }
}
